import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class NonComplianceListService {
  @SessionStorage() public user;

  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) { }

  // Function to get non compliance employee list
  getNonComplianceList(): Observable<any> {
    return this.httpService.get(`employee/list/NonCompliance`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Function to get non compliance employee list
  getNonAdherenceList(): Observable<any> {
    return this.httpService.post(`employee/listLockedEmployees`, '')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Function to unlock non compliance employee
  unlockNonCompliance(employees): Observable<any> {
    const data = {
      'employeeList': employees,
      'isNonCompliance': true
    };
    return this.httpService.post(`employee/unlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Function to unlock non adherence employee
  unlockNonAdherence(employees): Observable<any> {
    const data = {
      'employeeList': employees,
    };
    return this.httpService.post(`employee/unlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Function to search employee
  searchEmployee(searchTerm: string, searchType: boolean, pageNumber: number): Observable<any> {
    const data = {
      'searchText': searchTerm,
      'isNonCompliance': searchType,
      'pageSize': 15,
      'pageNumber': pageNumber
    };
    return this.httpService.post(`employee/lockList/search`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Function to handle error from observable
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/non-compliance-list/non-compliance-list.service.ts